import React from 'react'

const Footer = ({ children }) => (
    <footer className="footer site-footer">
        <span className="site-footer-logo">
            <span className="site-title-text">Verkehrswacht</span>
        </span>
        <div className="site-footer-social">
            <a href="https://www.instagram.com/fahrsicherheitscentrum/" className="social-instagram" target="_blank"><span className="sr-only">Instagram</span></a>
            <a href="https://www.facebook.com/fahrsicherheitscentrum/" className="social-facebook" target="_blank"><span className="sr-only">facebook</span></a>
        </div>
        <div className="site-footer-content">
            <a href="https://vir-group.de/fahrsicherheits-centrum/impressum">Impressum</a>
            <span> - <a href="https://vir-group.de/fahrsicherheits-centrum/datenschutz">Datenschutzerklärung</a></span>
            <span> - <a href="https://vir-group.de/fahrsicherheits-centrum/agb/">AGB</a></span>
        </div> 
    </footer>  
)

export default Footer


// WEBPACK FOOTER //
// ./src/components/Footer.js